import axios from "axios";

export const COURSE_URL = "/Course";
export const SCHOOL_REPORT_URL = "/SchoolReport";

/** Belli Bir Okul Karnesi Listesini Elde Eder */
export function getSchoolReports(queryParams) {
  return axios.post(`${SCHOOL_REPORT_URL}/GetSchoolReports`, queryParams);
}

/** Belli Bir Okul Karnesi Listesini Sayfalama Olmadan Elde Eder */
export function getAllSchoolReports(queryParams) {
  return axios.post(`${SCHOOL_REPORT_URL}/GetAllSchoolReports`, queryParams);
}

/** Yeni Bir Okul Karnesi Elde Eder */
export function getNewSchoolReport() {
  return axios.get(SCHOOL_REPORT_URL);
}

/** Belli Bir Okul Karnesini Elde Eder */
export function getSchoolReport(id) {
  return axios.get(`${SCHOOL_REPORT_URL}/${id}`);
}
 
/** Mevcut Okulun Belli Bir Karne Öğrencileri Listesini Elde Eder */
export function getStudents(queryParams) {
  return axios.post(`${SCHOOL_REPORT_URL}/GetStudents`, queryParams);
}

/** Mevcut Okulun Belli Bir Karne Sınıfları Listesini Elde Eder */
export function getSections(queryParams) {
  return axios.post(`${SCHOOL_REPORT_URL}/GetSections`, queryParams);
}

/** Mevcut Okulun Ders Listesini Elde Eder */
export function getCourses() {
  return axios.get(`${COURSE_URL}/GetCourses`);
}

/** Belli Bir Okul Karnesini Kaydeder */
export function saveSchoolReport(schoolReport) {
  return axios.post(SCHOOL_REPORT_URL, schoolReport);
}

/** Belli Bir Okul Karnesine Ait Modül Listesini Kaydeder */
export function saveModules(entityId, datas) {
  return axios.post(`${SCHOOL_REPORT_URL}/SaveModules`, { entityId, datas });
}

/** Belli Bir Okul Karnesinin Hazırlanacağı Öğrenci veya Sınıf Listesini Kaydeder */
export function saveReceipents(entityId, datas) {
  return axios.post(`${SCHOOL_REPORT_URL}/SaveReceipents`, { entityId, datas });
}

/** Belli Bir Okul Karnesini Basıma Gönderir */
export function sendToPrint(schoolReport) {
  return axios.post(`${SCHOOL_REPORT_URL}/SendToPrint`, schoolReport);
}

/** Belli Bir Okul Karnesi Listesini Siler */
export function deleteSchoolReports(ids) {
  return axios.post(`${SCHOOL_REPORT_URL}/Delete`, { ids });
}